export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11504.d3b8d5d6.jpg";